import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

export default function NicknameModal({ isOpen, initialName = '', onSelect, onClose }) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) setName(initialName);
  }, [isOpen, initialName]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (name.trim()) {
      onSelect(name.trim());
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="relative w-full max-w-md rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-[#111] p-8 shadow-2xl transition-colors"
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute right-4 top-4 rounded-lg p-2 text-gray-400 dark:text-gray-500 transition-colors hover:bg-gray-100 dark:hover:bg-white/10 hover:text-gray-950 dark:hover:text-white"
            >
              <SafeIcon icon={FiX} size={20} />
            </button>
            <h2 className="mb-2 text-center text-2xl font-bold text-gray-900 dark:text-white">
              {initialName ? 'Cambia tu apodo' : '¡Únete al Chat!'}
            </h2>
            <p className="mb-6 text-center text-sm text-gray-500 dark:text-gray-400">
              Este será el nombre que verán los demás participantes.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                autoFocus
                type="text"
                maxLength={20}
                value={name}
                onChange={(event) => setName(event.target.value)}
                placeholder="Tu apodo aquí..."
                className="w-full rounded-xl border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 px-4 py-3 text-gray-900 dark:text-white transition-colors focus:border-red-600 focus:outline-none"
              />
              <button
                disabled={!name.trim()}
                className="w-full rounded-xl bg-red-600 py-3 font-bold text-white transition-all hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {initialName ? 'Guardar nuevo apodo' : 'Empezar a chatear'}
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}